var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { injectIntl } from 'react-intl';
import _ from 'lodash';
import { observer } from 'mobx-react';
import * as Atlas from 'azure-maps-control';
import { ApplicationContext } from '../../../ApplicationContext';
import Settings from '../../../data/Settings';
import AssetSignals from './signals/AssetSignals';
import HtmlMarkerLayer from './markers/HtmlMarkerLayer';
import PieChartHTMLMarker from './markers/PieChartHTMLMarker';
import { addEvent } from './markers/markerUtils';
import ViewOptions from './data/ViewOptions';
import Signals from '../../../signals/Signals';
import MapStyleToggle from '../../components/ui/MapStyleToggle/MapStyleToggle';
import AssetClusterTableOverlay from "./AssetClusterTableOverlay";
import "external-svg-loader";
import Color from 'color';
/**
 * https://docs.microsoft.com/en-us/azure/azure-maps/how-to-use-map-control
 * Examples https://azuremapscodesamples.azurewebsites.net/
 *
 * PIE chart https://azuremapscodesamples.azurewebsites.net/HTML%20Markers/HtmlMarkerLayer/Clustered%20Pie%20Chart%20HTML%20Markers.html
 */
var AssetsMap = /** @class */ (function (_super) {
    __extends(AssetsMap, _super);
    /**
     *
     * @param props
     */
    function AssetsMap(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.onMapReady = _this.onMapReady.bind(_this);
        _this.onMarkerClicked = _this.onMarkerClicked.bind(_this);
        _this.onTooltipCallback = _this.onTooltipCallback.bind(_this);
        _this.onMapStyleChange = _this.onMapStyleChange.bind(_this);
        _this.zoomTo = _this.zoomTo.bind(_this);
        _this.zoomOut = _.debounce(_this.zoomOut.bind(_this), 250);
        _this.resizeMap = _this.resizeMap.bind(_this);
        return _this;
    }
    /**
     *
     */
    AssetsMap.prototype.componentDidMount = function () {
        this.initializeMap();
        AssetSignals.zoomTo.add(this.zoomTo);
        AssetSignals.zoomOut.add(this.zoomOut);
        Signals.AssetsRetrieved.addOnce(this.zoomOut);
        Signals.ResizeMap.add(this.resizeMap);
    };
    /**
     *
     * @param nextProps
     * @param nextState
     * @param nextContext
     */
    AssetsMap.prototype.componentWillUpdate = function (nextProps, nextState, nextContext) {
        var _a = this.props, assetCollection = _a.assetCollection, ignoreFilters = _a.ignoreFilters;
        var dataSource = this.state.dataSource;
        if (dataSource) {
            var options = dataSource.getOptions();
            options.clusterProperties = assetCollection.clusterType.properties;
            dataSource.setOptions(options);
            if (ignoreFilters) {
                dataSource.setShapes(assetCollection.list.filter(function (assetModel) { return assetModel.hasLocation; }));
            }
            else {
                dataSource.setShapes(assetCollection.filtered.filter(function (assetModel) { return assetModel.hasLocation; }));
            }
        }
        this.updateLayers();
    };
    /**
     *
     */
    AssetsMap.prototype.componentWillUnmount = function () {
        AssetSignals.zoomTo.remove(this.zoomTo);
        AssetSignals.zoomOut.remove(this.zoomOut);
        Signals.ChangeAssetViewState.remove(this.resizeMap);
    };
    /**
     *
     * @return {*}
     */
    AssetsMap.prototype.render = function () {
        var assetCollection = this.props.assetCollection;
        var count = assetCollection.filtered.length; // Required to listen to mobx changes
        var clusterType = assetCollection.clusterType; // Required to listen to mobx changes
        return React.createElement("div", { className: "asset-map" },
            React.createElement("div", { id: "azure-map" }),
            React.createElement(MapStyleToggle, { onChange: this.onMapStyleChange }));
    };
    /**
     *
     */
    AssetsMap.prototype.initializeMap = function () {
        // @ts-ignore
        var map = new Atlas.Map('azure-map', Settings.AZURE_MAPS_OPTIONS);
        map.events.add('ready', this.onMapReady);
        this.setState({ map: map });
    };
    /**
     *
     * @param event
     */
    AssetsMap.prototype.onMapReady = function (event) {
        var _this = this;
        var assetCollection = this.props.assetCollection;
        var map = event.map;
        var popup = new Atlas.Popup({
            pixelOffset: [0, -10]
        });
        var clusterType = assetCollection.clusterType;
        // GeoJSON format
        // https://docs.microsoft.com/en-us/javascript/api/azure-maps-control/atlas.source.datasource?view=azure-maps-typescript-latest
        var dataSource = new Atlas.source.DataSource(null, {
            cluster: true,
            clusterProperties: clusterType.properties
        });
        map.sources.add(dataSource);
        this.setState({ dataSource: dataSource, popup: popup, map: map }, function () {
            _this.updateLayers();
        });
        // Trigger first render
        this.props.assetCollection.update();
        map.resize();
        // Fit assets
        this.zoomOut();
    };
    /**
     *
     */
    AssetsMap.prototype.updateLayers = function () {
        //
        //Create a HTML marker layer for rendering data points.
        var onMarkerClicked = this.onMarkerClicked;
        var onTooltipCallback = this.onTooltipCallback;
        var assetCollection = this.props.assetCollection;
        var assetIconNameToIconUrlDictionary = this.context.assetIconNameToIconUrlDictionary;
        var _a = this.state, dataSource = _a.dataSource, map = _a.map;
        var clusterType = assetCollection.clusterType;
        var viewOption = assetCollection.viewOption;
        if (!dataSource) {
            return;
        }
        // Remove previous
        if (this.htmlMarkerLayer) {
            map.layers.remove(this.htmlMarkerLayer);
        }
        //
        var markerSVGTemplateLight = '<svg xmlns="http://www.w3.org/2000/svg" width="{width}" height="28" viewBox="0 0 {width} 28" xml:space="preserve"><rect width="{width}" height="20" rx="2" fill="{color}"/><polygon points="{pxl} 19.98 {pxr} 19.98 {pxm} 27.98 {pxl} 19.98" fill="{color}"/><text x="{pxm}" y="13" style="isolation:isolate;font-size:10px;font-family:ArialMT, Arial, serif" text-anchor="middle" fill="#000">{text}</text></svg>';
        var markerSVGTemplateDark = '<svg xmlns="http://www.w3.org/2000/svg" width="{width}" height="28" viewBox="0 0 {width} 28" xml:space="preserve"><rect width="{width}" height="20" rx="2" fill="{color}"/><polygon points="{pxl} 19.98 {pxr} 19.98 {pxm} 27.98 {pxl} 19.98" fill="{color}"/><text x="{pxm}" y="13" style="isolation:isolate;font-size:10px;font-family:ArialMT, Arial, serif" text-anchor="middle" fill="#F2F2F2">{text}</text></svg>';
        // Create new
        var markerLayer = new HtmlMarkerLayer(dataSource, null, {
            markerRenderCallback: function (id, position, properties) {
                var value = null;
                switch (viewOption) {
                    case ViewOptions.ACTIVITY:
                        value = properties.activityStatus;
                        break;
                }
                var color = clusterType.colors[clusterType.order.indexOf(value)];
                var template = color === '#F2F2F2' ? markerSVGTemplateLight : markerSVGTemplateDark;
                var iconSrc = properties.iconName ? assetIconNameToIconUrlDictionary.get(properties.iconName) : "";
                var label = properties.displayedId;
                var labelWidth = (label.length + 2) * 6;
                var pinWidth = 65;
                var pinHeight = 100;
                var iconMargin = 10;
                var iconSize = Math.min(pinWidth, pinHeight) - iconMargin;
                var iconSvgTemplate = '<svg style="overflow:visible" width={pinWidth} height={pinHeight}>' +
                    '<image x="0"y="0" href="/assets/images/map_marker/Pin.png" width={pinWidth} height={pinHeight} />' +
                    '<g>' +
                    '<svg x={iconMargin} y={iconMargin} data-src={iconSrc} fill={svgColor} stroke={svgColor} height={iconSize} width={iconSize} />' +
                    '</g>' +
                    '<rect y="-17.5" x="{pxl}" width="{width}" height="20" rx="2" fill="{color}"/>' +
                    '<text x="{pxm}" y="-5" style="isolation:isolate;font-size:10px;font-family:ArialMT, Arial, serif" text-anchor="middle" fill={textColor}>{text}</text>' +
                    '</svg>';
                var iconSvg = iconSvgTemplate.split('{iconSrc}').join(iconSrc + '')
                    .split('{iconMargin}').join(iconMargin / 2 + '')
                    .split('{iconSize}').join(iconSize + '')
                    .split('{pinWidth}').join(pinWidth + '')
                    .split('{pinHeight}').join(pinHeight + '')
                    .split('{width}').join(labelWidth + '')
                    .split('{pxm}').join(pinWidth / 2 + '')
                    .split('{pxl}').join((pinWidth / 2 - labelWidth / 2) + '')
                    .split('{svgColor}').join(Color(properties.iconColorRgba).hex() + '')
                    .split('{textColor}').join(color === '#F2F2F2' ? '#000' : '#F2F2F2');
                var parsedTemplate = template
                    .split('{width}').join(labelWidth + '')
                    .split('{pxl}').join((labelWidth / 2) - 5 + '')
                    .split('{pxr}').join((labelWidth / 2) + 5 + '')
                    .split('{pxm}').join((labelWidth / 2) + '');
                var marker = new Atlas.HtmlMarker({
                    htmlContent: properties.iconName ? iconSvg : parsedTemplate,
                    text: label,
                    position: position,
                    color: color,
                    pixelOffset: properties.iconName ? [0, 0] : [0, -14]
                });
                addEvent('click', marker, onMarkerClicked);
                return marker;
            },
            clusterRenderCallback: function (id, position, properties) {
                var radius = 35;
                if (properties.point_count > 1000) {
                    radius = 45;
                }
                else if (properties.point_count > 100) {
                    radius = 40;
                }
                //Get the counts for each entity type in the cluster.
                var values = [];
                clusterType.entities.forEach(function (type, index) {
                    values[index] = properties[type];
                });
                // Render PieChart
                var cluster = new PieChartHTMLMarker({
                    position: position,
                    values: values,
                    colors: clusterType.colors,
                    radius: radius,
                    strokeThickness: 1,
                    strokeColor: 'white',
                    innerRadius: radius - 10,
                    text: properties.point_count_abbreviated
                }, onTooltipCallback);
                addEvent('click', cluster, onMarkerClicked);
                return cluster;
            }
        });
        map.layers.add([markerLayer]);
        this.htmlMarkerLayer = markerLayer;
    };
    /**
     *
     * @param marker
     * @param sliceIdx
     * @return {string}
     */
    AssetsMap.prototype.onTooltipCallback = function (marker, sliceIdx) {
        var assetCollection = this.props.assetCollection;
        var clusterType = assetCollection.clusterType;
        return clusterType.entities[sliceIdx] + '<br/>' + marker.getSliceValue(sliceIdx) + ' (' + marker.getSlicePercentage(sliceIdx) + '%)';
    };
    /**
     *
     * @param eventType
     * @param marker
     */
    AssetsMap.prototype.onMarkerClicked = function (eventType, marker) {
        var _a = this.state, dataSource = _a.dataSource, map = _a.map;
        // Cluster
        if (marker.properties.cluster) {
            this.openCluster(marker.properties.cluster_id, marker.getOptions().position);
            // Single marker
        }
        else {
            var assetCollection = this.props.assetCollection;
            var assetModel = assetCollection.findById(marker.id);
            if (assetModel) {
                Signals.ShowAssetDetail.dispatch(assetModel);
            }
        }
    };
    AssetsMap.prototype.openCluster = function (clusterId, position) {
        var _this = this;
        var _a = this.state, dataSource = _a.dataSource, map = _a.map;
        dataSource.getClusterLeaves(clusterId, 1000).then(function (response) {
            _this.showClusterAssets(response, clusterId, position);
        });
    };
    /**
     *
     * @param response
     * @param clusterId
     * @param position
     */
    AssetsMap.prototype.showClusterAssets = function (response, clusterId, position) {
        var _this = this;
        var assetCollection = this.props.assetCollection;
        var assets = [];
        response.map(function (item) {
            assets.push(assetCollection.findById(item.data.id));
        });
        Signals.ShowOverlay.dispatch(React.createElement(AssetClusterTableOverlay, { assets: assets, clusterId: clusterId, position: position, onZoom: function (clusterId, position) {
                _this.zoomCluster(clusterId, position);
            } }));
    };
    /**
     *
     */
    AssetsMap.prototype.zoomCluster = function (clusterId, position) {
        var _a = this.state, dataSource = _a.dataSource, map = _a.map;
        //Get the cluster expansion zoom level. This is the zoom level at which the cluster starts to break apart.
        dataSource.getClusterExpansionZoom(clusterId).then(function (zoom) {
            //Update the map camera to be centered over the cluster.
            map.setCamera({
                center: position,
                zoom: zoom,
                type: 'ease',
                duration: 300
            });
        });
    };
    /**
     *
     */
    AssetsMap.prototype.onMapStyleChange = function (mapStyle) {
        var map = this.state.map;
        map.setStyle({ style: mapStyle });
    };
    /**
     *
     */
    AssetsMap.prototype.zoomTo = function (assetModel) {
        var _a = this.state, dataSource = _a.dataSource, map = _a.map;
        var shape = dataSource.getShapeById(assetModel.id);
        // https://docs.microsoft.com/nl-nl/azure/azure-maps/zoom-levels-and-tile-grid?tabs=csharp
        map.setCamera({ center: shape.getCoordinates(), zoom: 17 });
    };
    /**
     *
     */
    AssetsMap.prototype.zoomOut = function () {
        var _a = this.props, assetCollection = _a.assetCollection, ignoreFilters = _a.ignoreFilters;
        var map = this.state.map;
        var assets = ignoreFilters ? assetCollection.list : assetCollection.filtered;
        if (assets.length > 0) {
            if (ignoreFilters) {
                var boundingBox = assetCollection.boundingBox;
                map.setCamera({ maxZoom: 17, bounds: boundingBox, padding: { top: 96, left: 64, bottom: 64, right: 64 } });
            }
            else {
                var boundingBox = assetCollection.filteredBoundingBox;
                map.setCamera({ maxZoom: 17, bounds: boundingBox, padding: { top: 96, left: 64, bottom: 64, right: 64 } });
            }
        }
    };
    /**
     *
     */
    AssetsMap.prototype.resizeMap = function () {
        var map = this.state.map;
        if (map) {
            map.resize();
        }
    };
    AssetsMap = __decorate([
        observer
    ], AssetsMap);
    return AssetsMap;
}(React.Component));
AssetsMap.contextType = ApplicationContext;
export default injectIntl(AssetsMap);
